(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maklenn-curved-community-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mk-curved-gallery')) return;

    class MkCurvedGallery extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-curved-viewport]');
        this.panels = [...this.querySelectorAll('[data-curved-panel]')];
        this.frame = null;
        this.drag = null;

        if (!this.viewport || this.panels.length === 0) return;

        this.onScroll = () => this.requestUpdate();
        this.onResize = () => this.requestUpdate();
        this.onPointerDown = (event) => this.startDrag(event);
        this.onPointerMove = (event) => this.moveDrag(event);
        this.onPointerUp = () => this.endDrag();
        this.onClick = (event) => this.preventDragClick(event);

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        this.addEventListener('click', this.onClick, true);

        this.centerInitialPanel();
        this.requestUpdate();
      }

      disconnectedCallback() {
        if (!this.viewport) return;

        this.viewport.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        this.removeEventListener('click', this.onClick, true);
      }

      centerInitialPanel() {
        requestAnimationFrame(() => {
          const middle = this.panels[Math.floor(this.panels.length / 2)];
          if (!middle) return;

          const left = middle.offsetLeft - (this.viewport.clientWidth - middle.clientWidth) / 2;
          this.viewport.scrollLeft = Math.max(0, left);
          this.update();
        });
      }

      requestUpdate() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const viewportRect = this.viewport.getBoundingClientRect();
        const center = viewportRect.left + viewportRect.width / 2;
        const half = Math.max(viewportRect.width / 2, 1);

        this.panels.forEach((panel) => {
          const rect = panel.getBoundingClientRect();
          const panelCenter = rect.left + rect.width / 2;
          const progress = Math.max(-1.35, Math.min(1.35, (panelCenter - center) / half));
          const distance = Math.abs(progress);
          const isInward = this.dataset.bendDirection !== 'outward';
          const rotate = progress * (isInward ? -31 : -34);
          const scale = isInward
            ? 0.82 + Math.min(distance * 0.24, 0.28)
            : 1 - Math.min(distance * 0.14, 0.2);
          const translateY = isInward ? Math.max(0, 20 - distance * 13) : distance * 28;
          const translateZ = isInward ? -72 + Math.min(distance * 185, 176) : 86 - distance * 190;
          const opacity = isInward && distance > 1.06 ? 0 : 1;

          panel.style.setProperty('--curve-rotate', `${rotate.toFixed(2)}deg`);
          panel.style.setProperty('--curve-scale', scale.toFixed(3));
          panel.style.setProperty('--curve-y', `${translateY.toFixed(1)}px`);
          panel.style.setProperty('--curve-z', `${translateZ.toFixed(1)}px`);
          panel.style.setProperty('--curve-opacity', opacity);
          panel.style.zIndex = String(isInward ? Math.round(100 + distance * 100) : Math.round(200 - distance * 100));
          panel.style.pointerEvents = opacity === 0 ? 'none' : '';
        });
      }

      startDrag(event) {
        if (event.button !== 0) {
          return;
        }

        this.drag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          scrollLeft: this.viewport.scrollLeft,
          moved: false,
        };
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      moveDrag(event) {
        if (!this.drag || this.drag.pointerId !== event.pointerId) return;

        const delta = event.clientX - this.drag.startX;
        if (Math.abs(delta) > 4) this.drag.moved = true;
        this.viewport.scrollLeft = this.drag.scrollLeft - delta;
      }

      endDrag() {
        if (!this.drag) return;

        this.wasDragged = this.drag.moved;
        this.viewport.classList.remove('is-dragging');
        this.drag = null;
      }

      preventDragClick(event) {
        if (!this.wasDragged) return;

        event.preventDefault();
        event.stopPropagation();
        this.wasDragged = false;
      }
    }

    customElements.define('mk-curved-gallery', MkCurvedGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
